"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginatorList = function (props) {
    if (props.paginator.page_count < 2) {
        return null;
    }
    var links = [];
    var format = gettext("Page %s of %s ");
    var search = new URLSearchParams(window.location.search);
    for (var i = 1; i <= props.paginator.page_count; i++) {
        var data_1 = [i, props.paginator.page_count];
        var text_1 = interpolate(format, data_1);
        search.set("page", i.toString());
        links.push(React.createElement("a", { onClick: props.click, className: "dropdown-item", href: "?" + search.toString() }, text_1));
    }
    var data = [props.paginator.page, props.paginator.page_count];
    var text = interpolate(format, data);
    return (React.createElement("div", { className: "p-3" },
        React.createElement("div", { className: "d-flex" },
            React.createElement("nav", { className: "PaginatorList" },
                React.createElement("ul", { className: "pagination m-0" },
                    props.paginator.previous ? (React.createElement("li", { className: "page-item" },
                        React.createElement("a", { onClick: props.click, className: "Page page-link", href: props.paginator.previous },
                            "<\u00A0",
                            gettext("Previous")))) : (React.createElement("li", { className: "page-item disabled" },
                        React.createElement("a", { className: "Page page-link", href: "#0", tabIndex: -1, "aria-disabled": true },
                            "<\u00A0",
                            gettext("Previous")))),
                    props.paginator.leading.map(function (page) { return (React.createElement("li", { className: "page-item" },
                        React.createElement("a", { onClick: props.click, className: "Page page-link", href: page.href }, page.page))); }),
                    React.createElement("li", { className: "page-item active" },
                        React.createElement("a", { href: "#0", className: "Page--Current page-link" }, props.paginator.page)),
                    props.paginator.trailing.map(function (page) { return (React.createElement("li", { className: "page-item" },
                        React.createElement("a", { onClick: props.click, className: "Page page-link", href: page.href }, page.page))); }),
                    props.paginator.next ? (React.createElement("li", { className: "page-item" },
                        React.createElement("a", { onClick: props.click, className: "Page page-link", href: props.paginator.next },
                            gettext("Next"),
                            "\u00A0>"))) : (React.createElement("li", { className: "page-item disabled" },
                        React.createElement("a", { className: "Page page-link", href: "#0", tabIndex: -1, "aria-disabled": true },
                            gettext("Next"),
                            "\u00A0>"))))))));
};
exports.default = PaginatorList;
